import React from 'react';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { smoothScrollToId } from '../utils/smoothScroll';
export function MidCTA() {
  return <section className="py-10 md:py-12 bg-surfaceLight/40 border-y border-slate-200" aria-label="Empezá ahora" data-id="element-226">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-227">
        <FadeIn data-id="element-228">
          <div className="relative bg-white rounded-3xl border border-amber/30 shadow-soft-lg px-6 py-7 md:px-10 md:py-8 text-center overflow-hidden" data-id="element-229">
            <div className="absolute -inset-1 rounded-[2rem] opacity-40 blur-lg pointer-events-none" aria-hidden="true" style={{
            background: 'linear-gradient(135deg, rgba(245,158,11,0.25) 0%, rgba(45,212,191,0.18) 100%)'
          }} data-id="element-230" />
            <div className="relative z-10" data-id="element-231">
              <span className="inline-flex items-center gap-2 px-3 py-1 mb-3 rounded-full border border-amber/30 bg-amber/10 text-amber-dark text-[10px] font-bold uppercase tracking-widest" data-id="element-232">
                <SparklesIcon className="w-3.5 h-3.5" aria-hidden="true" data-id="element-233" />
                Tu plan de 30 días empieza hoy
              </span>
              <h2 className="font-heading text-xl md:text-3xl font-extrabold text-slate-900 mb-2 leading-tight" data-id="element-234">
                ¿Listo para que la próxima tarea sea distinta?
              </h2>
              <p className="text-slate-600 text-sm md:text-base mb-5 max-w-xl mx-auto leading-snug" data-id="element-235">
                Empezá hoy con el sistema completo y dejá de improvisar en la
                mesa de matemáticas.
              </p>
              <button onClick={() => smoothScrollToId('elegir-plan')} className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-3.5 text-base md:text-lg font-extrabold text-white bg-amber rounded-2xl hover:bg-amber-dark transition-all duration-300 shadow-glow-amber hover:-translate-y-1 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber" data-id="element-236">
                Quiero empezar mis 30 días
                <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-237" />
              </button>
              <p className="text-xs text-slate-500 font-bold mt-4" data-id="element-238">
                🛡️ Garantía 7 días · ⚡ Acceso de inmediato
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}